import PcoWorkflowTemp from './pages/PcoWorkflowTempPage.vue'

const routes = [
  {
    path: 'pco-workflow-temp',
    name: 'pco-workflow-temp',
    component: PcoWorkflowTemp
  }
]

export default routes